import React from 'react';
import { ACLAuthorizationRequest } from '@/api/bol';
import { LogisticsObjectFormDialog } from '@/components/common/LogisticsObjectFormDialog';
import { defaultHumanMeanTemplate } from '@/utils/humanMeanDefaultTemplate';

export interface HumanMeanFormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { memberIdentifier: string; humanMeanJson: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => Promise<void>;
}

export const HumanMeanFormDialog: React.FC<HumanMeanFormDialogProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const handleSubmit = async (data: { memberIdentifier: string; jsonData: string; humanMeanJson?: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => {
    const transformedData = {
      memberIdentifier: data.memberIdentifier,
      humanMeanJson: data.humanMeanJson || data.jsonData,
      aclAuthorizations: data.aclAuthorizations,
    };

    await onSubmit(transformedData);
  };

  return (
    <LogisticsObjectFormDialog
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Create New HumanMean"
      jsonFieldName="humanMeanJson"
      defaultJsonTemplate={defaultHumanMeanTemplate()}
      jsonLabel="Enter a valid HumanMean JSON according to the SDL schema:"
      jsonHelperText="The JSON must conform to the HumanMean schema defined in the BOL API"
      submitButtonText="Create"
    />
  );
};
